module.exports = __webpack_public_path__ + "h5/img/wuzhouyp@2x.2bcac8e1.png";